var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('NavBar'),_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticClass:"mb-4"},[_c('hr'),_c('br'),_c('h2',[_vm._v("Access Denied")]),_c('p',[_vm._v("You do not have permission to access this page.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }